import AdBoard from '../../Team/AdBoard/AdBoard';
import NewBanner from '../Banner/NewBanner';
import Featured from '../Featured/Featured';
import ItesseractAbout from '../ItesseractAbout/ItesseractAbout';
import Kits from '../Kits/Kits';
import Testimonial from '../Testimonial/Testimonial';

const Home = () => {
  return (
    <div>
      <NewBanner></NewBanner>
      <Kits></Kits>
      <ItesseractAbout></ItesseractAbout>
      <Featured />
      <Testimonial></Testimonial>
      <AdBoard />
    </div>
  );
};

export default Home;
